export const zones = [
  {
    "name": "Soverom"
  },
  {
    "name": "Stue"
  },
  {
    "name": "Baderom"
  },
  {
    "name": "Sikringskap"
  },
  {
    "name": "Vaskerom"
  },
  {
    "name": "Utvendig"
  },
  {
    "name": "Generell"
  },
  {
    "name": "Gang"
  },
  {
    "name": "Kjøkken"
  },
  {
    "name": "Bad"
  },
  {
    "name": "Bod"
  },
  {
    "name": "Garasje"
  },
  {
    "name": "Varme"
  },
  {
    "name": "Lys"
  },
  {
    "name": "Sikringsskap"
  },
  {
    "name": "Generelt"
  },
  {
    "name": "Brytere"
  },
  {
    "name": "Stikk"
  },
  {
    "name": "Bryter"
  },
  {
    "name": "Kjøkken "
  },
  {
    "name": "Soverom "
  },
  {
    "name": "Vaskerom "
  },
  {
    "name": "Entré "
  },
  {
    "name": "Hall"
  },
  {
    "name": "Bad skjult "
  },
  {
    "name": "Bad synlig utstyr"
  },
  {
    "name": "Timer"
  },
  {
    "name": "Varmtvannstanker"
  },
  {
    "name": "Alarm "
  },
  {
    "name": "Dusj"
  },
  {
    "name": "Trondheim"
  },
  {
    "name": "Avløp"
  },
  {
    "name": "Kontor"
  },
  {
    "name": "Kabel"
  },
  {
    "name": "Småarbeid"
  },
  {
    "name": "Hems"
  },
  {
    "name": "Teknisk rom"
  },
  {
    "name": "Størremur"
  },
  {
    "name": "Støttemur"
  },
  {
    "name": "Disponibelt"
  },
  {
    "name": "Toalett/WC"
  },
  {
    "name": "waa"
  },
  {
    "name": "Service "
  },
  {
    "name": "Test"
  },
  {
    "name": "Bunnledning"
  },
  {
    "name": "Faste kostnader"
  },
  {
    "name": "Borettslag"
  },
  {
    "name": "Elektro"
  },
  {
    "name": "Sanitærutstyr"
  },
  {
    "name": "Blandebatteri"
  },
  {
    "name": "Teknisk VVS"
  },
  {
    "name": "Varmtvannsbereder"
  },
  {
    "name": "Vannstoppventil"
  },
  {
    "name": "Roth tappevannssystem "
  },
  {
    "name": "Rørstrekk"
  },
  {
    "name": "Kabler"
  },
  {
    "name": "Håndvaskområdet"
  },
  {
    "name": "Badstu"
  },
  {
    "name": "Annet rom"
  },
  {
    "name": "Fordelinger"
  },
  {
    "name": "Brytermateriell"
  },
  {
    "name": "Skjult installasjon"
  },
  {
    "name": "Belysning"
  },
  {
    "name": "Entre"
  },
  {
    "name": "Utvendig "
  },
  {
    "name": "Generelt "
  },
  {
    "name": "Ungdomsavdeling"
  },
  {
    "name": "Mediarom/trimrom"
  },
  {
    "name": "Nordlettvegen 4"
  },
  {
    "name": "Trapperom"
  },
  {
    "name": "Garderobe"
  },
  {
    "name": "Vare/tjeneste"
  },
  {
    "name": "Generelle satser"
  },
  {
    "name": "Bad "
  },
  {
    "name": "Servise "
  },
  {
    "name": "fordeling inntak jord  "
  },
  {
    "name": "Kjeller "
  },
  {
    "name": "1 etg"
  }
].map(zone => zone.name)